/**
 * sticky-uniq-section.js
 * Universal sticky bar controller — scroll-trigger + hide behaviour + close.
 */
(function () {
  'use strict';

  function initBar(bar) {
    var showAfter    = parseInt(bar.dataset.showAfter || '0', 10);
    var hideBehavior = bar.dataset.hideBehavior || 'always'; // 'always' | 'on_scroll_up'
    var lastScrollY  = window.scrollY;
    var ticking      = false;
    var dismissed    = false;

    // ── Close button ───────────────────────────────────────────
    var closeBtn = bar.querySelector('.sticky-uniq__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dismissed = true;
        hide();
      });
    }

    // ── Visibility helpers ─────────────────────────────────────
    function show() {
      bar.classList.add('is-visible');
      bar.classList.remove('is-hidden');
    }

    function hide() {
      bar.classList.remove('is-visible');
      bar.classList.add('is-hidden');
    }

    // ── Core logic ─────────────────────────────────────────────
    function update() {
      if (dismissed) return;

      var scrollY      = window.scrollY;
      var pastThreshold = scrollY >= showAfter;

      if (!pastThreshold) {
        hide();
        lastScrollY = scrollY;
        return;
      }

      if (hideBehavior === 'on_scroll_up') {
        // Hide when scrolling up, show when scrolling down (or stationary)
        if (scrollY < lastScrollY) {
          hide();
        } else {
          show();
        }
      } else {
        // Always visible once past the threshold
        show();
      }

      lastScrollY = scrollY;
    }

    // ── Scroll listener (rAF-throttled) ───────────────────────
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Run once on load in case the page is already scrolled
    update();
  }

  // ── Boot ────────────────────────────────────────────────────
  function boot() {
    document.querySelectorAll('.sticky-uniq').forEach(function (bar) {
      initBar(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
